import { render, staticRenderFns } from "./User_Suspend.vue?vue&type=template&id=20b82937&scoped=true&"
import script from "./User_Suspend.vue?vue&type=script&lang=js&"
export * from "./User_Suspend.vue?vue&type=script&lang=js&"
import style0 from "./User_Suspend.vue?vue&type=style&index=0&id=20b82937&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b82937",
  null
  
)

export default component.exports